import { animate, style, transition, trigger } from '@angular/animations';
import { UserMenuListResponseModel } from 'src/app/store/userMenuList/userMenuList.model';

export interface INavbarData {
  route_link: string;
  icon?: string;
  menu_name: string;
  menu_code: string;
  is_catalogue?: string;
  tabs?: any;
  expanded?: boolean;
  sub_menu_name: string;
  items?: INavbarData[];
  isActive?: boolean;
}

export interface VehicleType {
  code: string;
  name: string;
  id: string;
}

export interface Vehicles extends VehicleType {
  icon: string;
}

export interface MenuListResponse {
  status: boolean;
  data: {
    code: string;
    message: string;
    response: UserMenuListResponseModel[];
  };
}

export interface Menu {
  menu_name: string;
  menu_code: string;
  icon: string;
  display_order: number;
  is_catalogue?: string;
  items: SubMenu[];
  route_link?: string;
}

export interface SubMenu {
  sub_menu_name: string;
  sub_menu_code: string;
  sub_menu_icon: string;
  route_link: string;
  display_order: number;
  actions: Action[];
}

interface Action {
  action_name: string;
  action_code: string;
  type: string;
}

export const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('350ms', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    style({ opacity: 1 }),
    animate('350ms', style({ opacity: 0 })),
  ]),
]);

export enum VehicleTypeCode {
  VC01 = 0,
  VC02 = 1,
  VC03 = 2,
  VC04 = 3,
}
